import React from 'react';
import { Box, NakedButton, Text } from '@qga/roo-ui/components';
import { formatInTimeZone } from 'date-fns-tz';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import Tile from '@shared/propTypes/Tile';
import ToggleContent from '@shared/v2/components/ToggleContent';

import ProcuredOfferModal from '@/components/ProcuredOfferOption/components/ProcuredOfferModal';
import useSearchQuery from '@/hooks/useSearchQuery';
import { MEDIUM_DATE_FORMAT } from '@/lib/date/format';
import getPrimaryOrigin from '@/utils/getPrimaryOrigin';
import { getOriginName } from '@/v2/utils/getOriginName';
import SearchQuery from '../../propTypes/SearchQuery';
import { getNights } from '../../utils/getStaySummaryText/getStaySummaryText';

const TermsAndConditions = ({ tile, searchQuery }) => {
  const { procuredOffer, propertyContent } = tile;
  const { saleDateRange } = procuredOffer;
  const {
    leadInOffers: [{ minNumberOfNights }],
  } = procuredOffer.rooms[0];
  const {
    destination: { origins },
  } = propertyContent;

  const { name: originName } = getPrimaryOrigin(origins);
  const {
    searchQuery: { originCode },
  } = useSearchQuery();
  const departingOriginName = getOriginName(originCode);

  const offerEnd = formatInTimeZone(
    saleDateRange.end.utc,
    saleDateRange.end.timezone,
    MEDIUM_DATE_FORMAT,
  );

  const minStay = pluralize(
    'night',
    searchQuery ? getNights(searchQuery) : minNumberOfNights,
    true,
  );

  return (
    <Box color="greys.steel" fontSize="xs" mt={4}>
      <Text fontSize="xs">
        {`
          Offer ends: ${offerEnd}.
          Price displayed is for ${minStay} in a specific room and
          return Economy Qantas flights departing ${
            departingOriginName || originName
          }.
          Other departure points may be available and specific travel periods may apply.
        `}
      </Text>
      <ToggleContent
        toggle={(open) => (
          <NakedButton textDecoration="underline" onClick={open}>
            View offer terms.
          </NakedButton>
        )}
        content={(close) => <ProcuredOfferModal onClose={close} tile={tile} />}
      />
    </Box>
  );
};

TermsAndConditions.propTypes = {
  tile: Tile.isRequired,
  searchQuery: PropTypes.shape(SearchQuery),
};

export default TermsAndConditions;
